import { render, staticRenderFns } from "./BecomeATeacher.vue?vue&type=template&id=6c3844a1&"
import script from "./BecomeATeacher.vue?vue&type=script&lang=js&"
export * from "./BecomeATeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports